import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import localforage from 'localforage';
import { applyMiddleware, compose, createStore } from 'redux';
import { PersistConfig, persistReducer, persistStore } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import thunk from 'redux-thunk';
import { axiosInstance, createRequestAuthInterceptor } from '~/api/config/axios.config';
import { createRootReducer } from './root-reducer';

const persistConfig: PersistConfig<any> = {
    key: 'root',
    version: 1,
    storage: localforage,
    stateReconciler: autoMergeLevel2,
    whitelist: ['user'],
};

// const dev = process.env.NODE_ENV === 'development';

const devtoolsCompose =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 50,
    });

export const configureStore = () => {
    const composeEnhancers = devtoolsCompose || compose;

    const browserHistory = createBrowserHistory();

    const rootReducer = createRootReducer(browserHistory);

    const persistedReducer = persistReducer(persistConfig, rootReducer);

    const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(routerMiddleware(browserHistory), thunk)));

    // @ts-ignore
    const persistor = persistStore(store);

    const authInterceptor = createRequestAuthInterceptor(store.getState);

    axiosInstance.interceptors.request.use(authInterceptor);

    return { store, persistor, browserHistory };
};
